import { useState } from "react";
import {ImportantNews2} from "../../";
import Right from "../../../assets/icon/NewsIcons/NewsRightBold2"
import Left from "../../../assets/icon/NewsIcons/NewsLeftBold2"
import moment from 'jalali-moment'

export const truncate = (str, len) => {
    if (str?.length > len && str?.length > 0) {
      let new_str = str + " ";
      new_str = str?.substr(0, len);
      new_str = str?.substr(0, new_str.lastIndexOf(" "));
      new_str = new_str.length > 0 ? new_str : str?.substr(0, len);
      return new_str + "...";
    }
    return str;
  };


const BottomNewses2 = (props) => {

    const MyCollection = [
        {
            title: " گرانی نفت و گاز در روزهای پر ریسک منطقه",
            text: "مصادیق عدم الزام به صدور صورتحساب الکترونیکی و ثبت در سامانه مودیان مشخص شد.",
            date: "یکشنبه 12 مهر",
            time: "7:12",
        },
        {
            title: "شروع جنگ روانی",
            text: "مصادیق عدم الزام به صدور صورتحساب الکترونیکی و ثبت در سامانه مودیان مشخص شد.",
            date: "دوشنبه 13 آبان",
            time: "8:17",
        },
        {
            title: "پیشرفت ایران در بین کشورهای خاورمیانه",
            text: "مصادیق عدم الزام به صدور صورتحساب الکترونیکی و ثبت در سامانه مودیان مشخص شد.",
            date: "شنبه 16 خرداد",
            time: "21:11",
        },
        {
            title: "گرانی دلار و سکه در بازار جهانی",
            text: "مصادیق عدم الزام به صدور صورتحساب الکترونیکی و ثبت در سامانه مودیان مشخص شد.",
            date: "چهارشنبه 14 مهر",
            time: "8:24",
        },
        {
            title: "گرانی نفت در خاورمیانه",
            text: "مصادیق عدم الزام به صدور صورتحساب الکترونیکی و ثبت در سامانه مودیان مشخص شد.",
            date: "پنجشنبه 21 مهر",
            time: "7:13",
        },
        {
            title: "تحلیل بورس در روزهای خطرناک",
            text: "مصادیق عدم الزام به صدور صورتحساب الکترونیکی و ثبت در سامانه مودیان مشخص شد.",
            date: "شنبه 16 خرداد",
            time: "12:13",
        },
    ];

    
    
        const CollectionSize = MyCollection.length;
        const [index2, setActiveStep] = useState(4);

    const goToNextPicture = () => {
        if(index2<CollectionSize)
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const goToLastPicture = () => {
        if(index2>4){

            setActiveStep((prevActiveStep) => prevActiveStep - 1);
        }
    };


    return(
        <div className="mx-[74px] mt-[100px] md:mx-[10px] md:mt-[50px]">
            <div className="w-full flex justify-center items-center">
                <div className="w-[38px] h-[11px] bg-nextColor rounded-[50px] shadow-yellowShadow md:h-[8px] md:w-[35px]"></div>
                <div className="w-[11px] h-[11px] mr-[5px] bg-nextColor rounded-[50px] shadow-yellowShadow md:h-[8px] md:w-[8px]"></div>
                <p className="text-[30px] text-mainColor2 font-IRANYekanExtra mx-[15px] md:text-[20px]">{props.children}</p>
                <div className="w-[11px] h-[11px] ml-[5px] bg-nextColor rounded-[50px] shadow-yellowShadow md:h-[8px] md:w-[8px]"></div>
                <div className="w-[38px] h-[11px] bg-nextColor rounded-[50px] shadow-yellowShadow md:h-[8px] md:w-[35px]"></div>
            </div>
            
            <div className="w-[100%] flex  flex-wrap opacity-100 mt-[60px] ">
            {
                    props?.data?.filter(x=>x.slug!=props.params).map((item,port)=>{
                        if(port<index2 && port>=index2-4 ) {  
                            console.log(port)
                        return(
                            <div className="w-[24%] mb-[30px] mx-[0.5%] a1475:w-[32%] b1115:w-[48%] md:mx-[1%] md:mb-[10px] c550:w-[98%]">
                                    <ImportantNews2
                                    imgPath={item?.mainPicture}
                                    title={item?.articleTittle}
                                    text={item ?
                                               truncate(item?.newsBox, 120) :
                                                  null}
                                    date={moment(item?.datePublished?.split("T")[0].replace("-", "/"), 'YYYY/MM/DD').locale('fa').format('YYYY/MM/DD')}
                                    time={item?.datePublished?.split("T")[1].substr(0, 5)}
                                    link={"/news/" + item?.articleCategories[0]?.category?.categorySlug + "/" + item?.slug}
                                    />
                                </div> 
                            
                        )
                    }
                    })
                }
                {/* <div className="w-[22.5%] mx-[1%] md:mx-[1%] md:w-[48%]"><BottomNews2/></div>
                <div className="w-[22.5%] mx-[1%] md:mx-[1%] md:w-[48%]"><BottomNews2/></div>
                <div className="w-[22.5%] mx-[1%] md:mx-[1%] md:w-[48%]" ><BottomNews2/></div>
                <div className="w-[22.5%] mx-[1%] md:mx-[1%] md:w-[48%]"><BottomNews2/></div> */}
            </div>
        </div>
    )
}

export default BottomNewses2;